export enum Role {
  SituSystemsAdmin = 'Situ Systems Admin',
  SituSystemsDeveloper = 'Situ Systems Developer',
  SituSystemsEmployee = 'Situ Systems Employee',
  AssetCreator = 'Asset Creator',
  BuilderAdmin = 'Builder Admin',
  PartnerAdmin = 'Partner Admin',
  Admin = 'Admin',
  User = 'User',
  ExternalProductContractor = 'ExternalProductContractor',
  CompanyProductPublisher = 'CompanyProductPublisher',
  Release = 'Release',
  ProductCatalog = 'ProductCatalog',
  Report = 'Report',
  Theme = 'Theme',

  SituFacade = 'SituFacade',
  SituView = 'SituView',
  SituPlan = 'SituPlan',
  SituRender = 'SituRender',
  SituFurnish = 'SituFurnish',
  SituVr = 'SituVr',
  SituConnect = 'SituConnect',
  SituVanity = 'SituVanity',
  SituLandscape = 'SituLandscape',
  SituDaydream = 'SituDaydream',

  // --- Portal Access Model department bundles ---
  // A builder or supplier is an organisation, not one login, so the team needs a
  // role that says which department a user sits in. These are additive: Builder
  // Admin and Partner Admin still carry account-level administration.
  // The strings must match dbo.Roles in Identity Server exactly (seeded by the
  // AccessModelRoles migration) or the claim silently resolves to nothing.
  BuilderAccountOwner = 'Builder Account Owner',
  BuilderDrafting = 'Builder Drafting',
  BuilderDesign = 'Builder Design',
  BuilderMarketing = 'Builder Marketing',
  BuilderSales = 'Builder Sales',

  SupplierAccountOwner = 'Supplier Account Owner',
  SupplierAccounts = 'Supplier Accounts',
  SupplierMarketing = 'Supplier Marketing',
  SupplierSales = 'Supplier Sales',
}

/** The bundles a builder's own admin may hand out to their team. */
export const BuilderBundleRoles: Role[] = [
  Role.BuilderAccountOwner,
  Role.BuilderDrafting,
  Role.BuilderDesign,
  Role.BuilderMarketing,
  Role.BuilderSales,
];

/** The bundles a supplier's own admin may hand out to their team. */
export const SupplierBundleRoles: Role[] = [
  Role.SupplierAccountOwner,
  Role.SupplierAccounts,
  Role.SupplierMarketing,
  Role.SupplierSales,
];
